import React, { useState } from "react";
import { Link } from "react-router-dom";

import LayoutAuth from "../components/layoutAuth";
import { authService } from "../services/auth";
import { getParameterByName } from "../utils/urls";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const autoLoggedOut = getParameterByName('autologgedout', window.location);

  const submitForm = (e) => {
    e.preventDefault();
    setLoading(true);

    authService.login(
      e.target.elements['email'].value,
      e.target.elements['password'].value,
      () => {
        setError(null);
        authService.fetchUser(() => {
          const next = getParameterByName('next', window.location);
          window.location = next || '/';
        }, () => {
          console.error("Failed to fetch user info");
        });
      },
      (err) => {
        setError(err?.response?.data?.detail || 'could not log in');
        setLoading(false);
      }
    );
  };

  return (
    <LayoutAuth title="Sign in to Weave" subtitle="Your sites, running while you sleep.">
      <form className="space-y-4" action="#" onSubmit={submitForm}>
        {autoLoggedOut && !error ? (
          <div className="rounded-md p-4 border border-theme-secondary bg-theme-secondary bg-opacity-40">
            <p className="text-sm text-theme-text">
              You were logged out from inactivity. Please log in again.
            </p>
          </div>
        ) : null}

        {error ? (
          <div className="rounded-md p-4 border border-red-500 border-opacity-50 bg-red-500 bg-opacity-10">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-500">
                  {error}
                </h3>
              </div>
            </div>
          </div>
        ) : ''}

        <div>
          <label htmlFor="email" className="block text-[12.5px] font-medium text-theme-text mb-1.5">
            Email address
          </label>
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            placeholder="you@example.com"
            className="appearance-none block w-full px-3.5 py-2.5 border border-theme-secondary rounded-lg bg-theme-main text-theme-text placeholder-opacity-60 focus:outline-none focus:ring-theme-primary focus:border-theme-primary text-[13.5px]"
          />
        </div>

        <div>
          <label htmlFor="password" className="block text-[12.5px] font-medium text-theme-text mb-1.5">
            Password
          </label>
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            placeholder="Enter your password"
            className="appearance-none block w-full px-3.5 py-2.5 border border-theme-secondary rounded-lg bg-theme-main text-theme-text placeholder-opacity-60 focus:outline-none focus:ring-theme-primary focus:border-theme-primary text-[13.5px]"
          />
        </div>

        <div className="pt-1.5">
          <button
            type="submit"
            className="cursor-pointer w-full flex justify-center py-2.5 px-4 border border-transparent rounded-lg text-sm font-semibold text-theme-button focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme-primary"
            disabled={loading}
            style={{
              backgroundColor: 'var(--theme-primary)',
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </div>
        <p className="text-center text-xs text-theme-text opacity-60">
          New here? <Link to="/register/" className="text-theme-primary font-medium">Create an account</Link>
        </p>
      </form>
    </LayoutAuth>
  );
};

export default Login;
